import Splide from '@splidejs/splide';
import { createXHR } from './utils';
import { startLoading, finishLoading } from './loading';

let courses = [];
let relatedOptions = null
let activeCourse = null;
const tabsMapper = {
    beginner: {
        title: 'Beginner',
    },
    intermediate: {
        title: 'Intermediate',
    },
    advanced: {
        title: 'Advanced',
    }
}

const init = async () => {
    const coursesDataEl = document.getElementById('courses-data');
    if (!coursesDataEl) {
        return;
    }
    courses = JSON.parse(coursesDataEl.innerHTML);
    if (courses === null) return;

    const courseSlug = window.location.pathname.split('/')[2];
    activeCourse = courses.filter(course => course.blob.slug === courseSlug)[0];

    if (!activeCourse) {
      return;
    }

    relatedOptions = {
        level: {
            splideElement: document.querySelector('.level-splide'),
            splideInstance: null,
            relatedContent: [],
            tabsContainer: document.getElementById('level-related-tabs-container'),
            cardsContainer: document.getElementById('level-related-cards-container'),
            activeTabIndex: 0
        },
        instrument: {
            splideElement: document.querySelector('.instrument-splide'),
            splideInstance: null,
            relatedContent: [],
            tabsContainer: document.getElementById('instrument-related-tabs-container'),
            cardsContainer: document.getElementById('instrument-related-cards-container'),
            activeTabIndex: 0
        },
    };

    startLoading(null, relatedOptions.level.tabsContainer, true);
    getRelatedContent('level').then((resp) => {
      const respArr = Array.from(resp);

      if (respArr.length === 0) {
        finishLoading(null, relatedOptions.level.tabsContainer);
        document.getElementById('related-what-to-learn').style.display = 'none';
        return;
      }

      relatedOptions.level.relatedContent = respArr;
      relatedOptions.level.relatedContent.forEach((elem, index) => {
          if (elem.name.toLowerCase() === activeCourse.blob.level) {
              relatedOptions.level.activeTabIndex = index;
          }
      });
      finishLoading(null, relatedOptions.level.tabsContainer);
      renderRelatedContent(relatedOptions.level);
    });

    startLoading(null, relatedOptions.instrument.tabsContainer, true);
    getRelatedContent('instrument').then((resp) => {
      const respArr = Array.from(resp);

      if (respArr.length === 0) {
        finishLoading(null, relatedOptions.instrument.tabsContainer);
        document.getElementById('related-students-like').style.display = 'none';
        return;
      }

      relatedOptions.instrument.relatedContent = Array.from(resp).slice(0, 10);
      relatedOptions.instrument.relatedContent.forEach((elem, index) => {
          if (elem.name === activeCourse.blob.instrument_names[0]) {
              relatedOptions.instrument.activeTabIndex = index;
          }
      });
      finishLoading(null, relatedOptions.instrument.tabsContainer);
      renderRelatedContent(relatedOptions.instrument);
    });
};

const getRelatedContent = (orderBy) => new Promise((resolve, reject) => {
    const xhr = createXHR({
        method: 'GET',
        endpoint: `/api/v2/course/related-content?product_id=${activeCourse.id}&order_by=${orderBy}`,
    });

    xhr.onload = () => {
        switch (xhr.status) {
            case 200:
                resolve(JSON.parse(xhr.response));
                break;
            default:
                reject('[RELATED CONTENT ERROR]: ' + xhr.status);
                break;
        }
    };
});

const renderRelatedContent = (options) => {
    const tabsContent = options.relatedContent.reduce((acc, tab, index) => {
        const tabTemplate = `<div id="${index}-related-tab" class="related-tab ${index === options.activeTabIndex ? 'active' : ''}">${tabsMapper[tab.name]?.title || tab.name}</div>`;
        return acc + tabTemplate;
    }, '');
    options.tabsContainer.innerHTML = tabsContent;

    const cardsContent = options.relatedContent[options.activeTabIndex].ids.reduce((acc, id) => {
        return acc + getCardTemplate(id);
    }, '');
    options.cardsContainer.innerHTML = cardsContent;

    options.tabsContainer.addEventListener('click', handleTabClick);
    options.cardsContainer.childNodes.forEach(card => {
        card.addEventListener('click', handleCardClick);
    })

    options.splideInstance = new Splide(options.splideElement, {
        type: 'slide',
        perPage: 6,
        gap: '2rem',
        breakpoints: {
            2500: {
              perPage: 5
            },
            1440: {
                perPage: 4
            },
            1200: {
                perPage: 3
            },
            1024: {
              perPage: 2
            },
            768: {
                perPage: 1,
            },
            641: {
              perPage: 1
            },
        }
    });
    options.splideInstance.mount();
}

const updateRelatedContent = (options) => {
    options.tabsContainer.childNodes.forEach((tab) => {
        if (tab.id.split('-')[0] === options.activeTabIndex) {
            tab.classList.add('active');

        } else {
            tab.classList.remove('active');
        }
    });

    options.splideInstance.destroy();

    const cardsContent = options.relatedContent[options.activeTabIndex].ids.reduce((acc, id) => {
        return acc + getCardTemplate(id);
    }, '');
    options.cardsContainer.innerHTML = cardsContent;
    options.cardsContainer.childNodes.forEach(card => {
        card.addEventListener('click', handleCardClick);
    })

    options.splideInstance.mount();
}

const getCourseById = (id) => {
    const course = courses.filter(course => course.id == id)[0];
    return course;
}

const getCardTemplate = (id) => {
    const course = getCourseById(id);
    if (!course) { return '' };
    const cardTemplate = `<div class="splide__slide related-course-card" data-slug="${course.blob.slug}">
                                <div class="cover" style="background-image: url('${course.image_url}');"></div>
                                <div class="title">${course.title}</div>
                                <div class="guru">with <a href="/gurus/${course.blob.artist.slug}/" class="guru-url">${course.blob.artist.display_name}</a></div>
                                <div class="lessons">${course.blob.length} lessons</div>
                            </div>`;
    return cardTemplate;
}

const handleTabClick = (event) => {
    if (event.target.id.endsWith('related-tab')) {
        switch (event.currentTarget.id.split('-')[0]) {
            case 'level':
                relatedOptions.level.activeTabIndex = event.target.id.split('-')[0];
                updateRelatedContent(relatedOptions.level);
                break;
            case 'instrument':
                relatedOptions.instrument.activeTabIndex = event.target.id.split('-')[0];
                updateRelatedContent(relatedOptions.instrument);
                break;
            default:
        }
    }
}

const handleCardClick = (event) => {
    window.location.assign(`/courses/${event.currentTarget.dataset.slug}/`);
}

export default { init };
